

<form #formDetails="ngForm">
    <div class="p-grid  p-grid-nogutter">
      <div class="p-col-12 p-field">
        <label for="name">Seleccione la columna a modificar</label>
        <!-- <p-cascadeSelect class=""
                                [(ngModel)]="selectedColumn.entity_field_id"
                                [options]="entitiesToFilter"
                                appendTo="body"
                                optionLabel="description"
                                optionValue="id"
                                optionGroupLabel="entity"
                                (onChange)="changeColumn($event, selectedColumn)"
                                [ngModelOptions]="{standalone: true}"
                                [optionGroupChildren]="['fields', 'subfields']" placeholder="Selecciona">
               </p-cascadeSelect>-->
        <p-dropdown placeholder="Seleccione" (onChange)="changeColumn($event, selectedColumn)" [(ngModel)]="selectedColumn.entity_field_id"
                    [options]="entitiesToFilter" [ngModelOptions]="{standalone: true}"
                    [showClear]="true" name="selectedColumns" appendTo="body" [filter]="true" optionLabel="description" optionValue="id"></p-dropdown>
      </div>
      <div class="p-col p-field" *ngIf="selectedColumn.entity_field_id != null">
        <label for="name">Indique el valor</label>

        <input *ngIf="getFilterOptionsOrValueType(selectedColumn) == 'input-text'" [ngModelOptions]="{standalone: true}" type="text" pInputText [(ngModel)]="selectedColumn.value" />
        <p-dropdown *ngIf="getFilterOptionsOrValueType(selectedColumn) == 'input-dropdown'"
                    [options]="filterValuesOptions[selectedColumn.entity_field_id]"
                    [(ngModel)]="selectedColumn.value"
                    placeholder="Seleccione"
                    [optionLabel]="getFilterComboOptionsText(selectedColumn, true)"
                    [optionValue]="getFilterComboOptionsText(selectedColumn, false)"
                    [showClear]="true" appendTo="body"
                    [ngModelOptions]="{standalone: true}"></p-dropdown>
        <p-calendar *ngIf="getFilterOptionsOrValueType(selectedColumn) == 'input-datetime'" dateFormat="dd/mm/yy" hourFormat="24" [showIcon]="true" [showTime]="true"
                    [(ngModel)]="selectedColumn.value" appendTo="body" [ngModelOptions]="{standalone: true}" [stepMinute]="15"></p-calendar>
        <input *ngIf="getFilterOptionsOrValueType(selectedColumn) == 'input-number'" [ngModelOptions]="{standalone: true}" type="number" pInputText [(ngModel)]="selectedColumn.value" />


        <p-dropdown *ngIf="getFilterOptionsOrValueType(selectedColumn) == 'boolean'"
                    [options]="yes_no"
                    [(ngModel)]="selectedColumn.value"
                    placeholder="Seleccione"
                    optionLabel="name"
                    optionValue="value"
                    [showClear]="true" appendTo="body"
                    [ngModelOptions]="{standalone: true}"></p-dropdown>

        <p-multiSelect *ngIf="getFilterOptionsOrValueType(selectedColumn, false) == 'dropdown-multiple'"
                       [options]="filterValuesOptions[selectedColumn.entity_field_id]"
                       [(ngModel)]="selectedColumn.value"
                       optionLabel="text"
                       optionValue="code"
                       placeholder="Seleccione" [filter]="true"
                       [showClear]="true" appendTo="body" [ngModelOptions]="{standalone: true}"></p-multiSelect>
      </div>
    
    </div>
      <div class="p-d-flex">
        <div class="flex-grow-1"></div>
        <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary p-button-text" (click)="cancel()"></p-button>
        <p-button label="Actualizar" icon="pi pi-check" styleClass="p-ml-2" (click)="updateColumns()"></p-button>
    </div>
</form>
